<template>
	<div class="page with-logo">
		<div class="logo-text">
			<div>
				<button @click="goToWithSeeds('search')" class="button back"/>
			</div>
		</div>
		<Basket
			v-if="basketEntities.length > 0"
			:basket-entities="basketEntities"
			@remove="removeEntityFromBasket"
			@goToSearch="goToWithSeeds('search')"
			@goToConfigure="goToWithSeeds('configure')">
		</Basket>
		<h1 class="what">
			{{ownerHeading}}
		</h1>
		<EventSelection
			:owner="owner"
			:basket="basket"
			:earliestPromotionIso="config.earliestPromotionIso"
			:shortestPromotionWindow="config.shortestPromotionWindow"
			@add="addEvents" />
	</div>
</template>

<script>
	import { EventBus }      from '../../event-bus'
	import Basket            from '../Basket'
	import EventSelection    from '../EventSelection'
	import basketHolderMixin from '../../mixins/basketHolder.js'

	export default {
		name: 'owner',
		components: {
			Basket,
			EventSelection,
		},

		props: [
			'config',    // Passed from router attribute (App.vue)
			'owner',     // Passed from router attribute (App.vue)
			'ownerType', // Passed from router
			'ownerId',   // Passed from router
		],

		mixins : [
			basketHolderMixin
		],

		data() {
			return {}
		},

		mounted () {
			if (!this.owner) {
				EventBus.$emit('get-owner', this.ownerType, this.ownerId)
			}
		},

		computed: {
			ownerHeading() {
				// Owner may not be available until grabbed from the server
				if (!this.owner) {
					return ''
				}

				switch(this.ownerType) {
					case 'artist':     return 'events for ' + this.owner.name; break;
					case 'venue':      return 'events at ' + this.owner.name;  break;
					case 'collection': return '' + this.owner.name + ' dates'; break;
				}
				return 'Events'
			}
		},

		methods : {
			addEvents(events){
				this.addEntitiesToBasket(events, 'items')
			}
		}
	}
</script>

<style lang="scss" scoped>

h2 {
	position: relative;

	.back {
		top:4px;
	}
}



</style>

